var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swab_sample-analysis-page__container"},[_c('SwabSampleAnalysisPageHeader'),(_vm.isSwabSampleCreated)?[_c('SwabSampleAnalysisChart'),_c('SwabSampleAnalysisTable')]:_c('EmptyAnalysisPlaceholder')],2)}
var staticRenderFns = []

export { render, staticRenderFns }